import React from "react";

const BookDemoModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle form submission logic here
    console.log("Form submitted");
    onClose();
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 p-4">
      <div className="bg-white rounded-lg shadow-xl max-w-4xl w-full max-h-[90vh] overflow-y-auto">
        <div className="p-4 md:p-8">
          <div className="flex justify-between items-center mb-4 md:mb-6">
            <h2 className="text-xl md:text-2xl font-semibold text-black">Book a Demo</h2>
            <button
              onClick={onClose}
              className="text-gray-500 hover:text-gray-700 text-2xl font-bold"
            >
              &times;
            </button>
          </div>

          <section className="w-full flex flex-col md:flex-row mt-4 md:mt-8 gap-6 md:gap-10">
            <div className="w-full md:w-1/2">
              <h3 className="text-2xl md:text-3xl font-medium text-black">
                Leave us a message
              </h3>
            </div>
            <div className="w-full md:w-1/2">
              <form className="space-y-4 md:space-y-6" onSubmit={handleSubmit}>
                <div className="flex flex-col gap-4">
                  <div className="flex flex-col w-full">
                    <label htmlFor="name" className="font-medium text-black mb-1">
                      Name
                    </label>
                    <input
                      type="text"
                      id="name"
                      placeholder="John Doe"
                      className="border rounded p-2 text-sm md:text-base"
                      required
                    />
                  </div>
                </div>
                  <div className="flex flex-col w-full">
                    <label htmlFor="company" className="font-medium text-black mb-1">
                      Email
                    </label>
                    <input
                      placeholder="john.doe@example.com"
                      type="email"
                      id="company"
                      className="border rounded p-2 text-sm md:text-base"
                      required
                    />
                  </div>
              
                <div className="flex flex-col">
                  <label htmlFor="message" className="font-medium text-black mb-1">
                    Message
                  </label>
                  <textarea
                    placeholder="Type Your Message"
                    id="message"
                    rows="4"
                    className="border rounded p-2 text-sm md:text-base"
                    required
                  ></textarea>
                </div>
                <div className="flex justify-end">
                  <button
                    type="submit"
                    className="bg-[#0050AE] text-white px-4 md:px-6 py-2 rounded hover:bg-[#003d8a] transition-colors text-sm md:text-base w-full md:w-auto"
                  >
                    Send Message
                  </button>
                </div>
              </form>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default BookDemoModal;
